// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import cognitoIcon from '../../Assets/cognito-icon.png'
import { useContext } from 'react';
import { ApiContext } from '../../App';
import { AppContent } from '../../context/AppContext';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const NEW_APP_URL = process.env.REACT_APP_NEW_APP_URL || 'http://localhost:3000';
const NEW_BACKEND_URL = process.env.REACT_APP_NEW_BACKEND_URL || 'http://localhost:3001';

const ClientNavbar = () => {
  const {userData, setUserData, setIsLoggedin} = useContext(AppContent);
  const API = useContext(ApiContext)
  const navigate = useNavigate()
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [newAppUser, setNewAppUser] = useState(null);

  // Vérifie l'auth de la nouvelle app via les cookies httpOnly
  useEffect(() => {
    if (userData) return;
    fetch(`${NEW_BACKEND_URL}/api/auth/me`, { credentials: 'include' })
      .then(res => res.ok ? res.json() : null)
      .then(user => { if (user?.id) setNewAppUser(user); })
      .catch(() => {});
  }, [userData]);

  // Normalise les deux formats de user pour l'affichage
  const effectiveUser = userData || (newAppUser
    ? { name: `${newAppUser.firstName} ${newAppUser.lastName}`, isAccountVerified: newAppUser.isAccountVerified }
    : null);

  const logout = async () => {
    if (newAppUser) {
      try {
        await fetch(`${NEW_BACKEND_URL}/api/auth/logout`, { method: 'POST', credentials: 'include' });
      } catch (e) {}
      localStorage.removeItem('auth-token');
      localStorage.removeItem('refresh-token');
      setNewAppUser(null);
      window.location.href = `${NEW_APP_URL}/login`;
      return;
    }
    try {
      await API.post('/auth/logout');
    } catch (error) {}
    localStorage.removeItem('auth-token');
    sessionStorage.clear();
    window.location.href = NEW_APP_URL;
  }

  const sendVerificationOtp = async () => {
    try {
      const {data} = await API.post('/api/send-verify-otp')

      if(data.success){
        navigate('/email-verify')
      }else{
        toast.error(data.message)
      }

    } catch (error) {
      toast.error(error.message)
    }
  }

  const fonctionnalitesMenu = [
    {
      title: "CVthèque",
      description: "Gérez et organisez votre base de candidats",
      icon: <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>,
      link: "/cvtheque"
    },
    {
      title: "Reporting",
      description: "Analysez vos performances de recrutement",
      icon: <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>,
      link: "/reporting"
    },
    {
      title: "Evaluation",
      description: "Système de notation et d'évaluation des candidats",
      icon: <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>,
      link: "/evaluation"
    },
    {
      title: "Extension Chrome",
      description: "Intégration directe avec LinkedIn",
      icon: <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>,
      link: "/extension"
    },
    {
      title: "Filtres Avancés",
      description: "Recherche et filtrage intelligent",
      icon: <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" /></svg>,
      link: "/filtres"
    }
  ];

  const ressourcesMenu = [
    {
      title: "Blog",
      description: "Actualités et conseils RH",
      icon: <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>,
      link: "/blog"
    },
  ];

  /*
      {
      title: "Documentation",
      description: "Guide d'utilisation complet",
      icon: <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>,
      link: "/docs"
    },
    {
      title: "Tutoriels",
      description: "Apprenez à utiliser Jobrise",
      icon: <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>,
      link: "/tutorials"
    },
    {
      title: "Support",
      description: "Contactez notre équipe",
      icon: <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg>,
      link: "/support"
    }
    */

  const handleMouseEnter = (dropdown) => {
    setActiveDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  return (
    <nav className="bg-white text-black border-b border-slate-300 shadow-sm relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to='/' className='no-underline text-slate-900 flex items-center gap-3 flex-shrink-0'>
            <img src={cognitoIcon} alt="Cognito Logo" className="w-8 h-8" />
            <h1 className="text-lg font-bold mb-0">Jobrise</h1>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-4">
            {/* Menu Fonctionnalités */}
            <div 
              className='relative'
              onMouseEnter={() => handleMouseEnter('fonctionnalites')}
              onMouseLeave={handleMouseLeave}
            >
              <button className="hover:bg-gray-100 px-4 py-2 text-black rounded-2xl transition-colors flex items-center">
                Fonctionnalités
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {activeDropdown === 'fonctionnalites' && (
                <div className="absolute top-full left-0 w-80 bg-white rounded-lg shadow-lg border border-slate-200 z-50">
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-slate-500 mb-3 uppercase tracking-wide">Fonctionnalités</h3>
                    {fonctionnalitesMenu.map((item, index) => (
                      <Link
                        key={index}
                        to={item.link}
                        className="block p-3 rounded-lg hover:bg-slate-50 transition-colors text-decoration-none text-black mb-2"
                      >
                        <div className="flex items-start">
                          <div className="text-indigo-600 mr-3 border rounded-lg p-2 flex-shrink-0">{item.icon}</div>
                          <div>
                            <h4 className="font-medium text-slate-900 mb-1 text-base">{item.title}</h4>
                            <p className="text-sm text-slate-600">{item.description}</p>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Menu Ressources */}
            <div 
              className='relative'
              onMouseEnter={() => handleMouseEnter('ressources')}
              onMouseLeave={handleMouseLeave}
            >
              <button className="hover:bg-gray-100 px-4 py-2 text-black rounded-2xl transition-colors flex items-center">
                Ressources
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {activeDropdown === 'ressources' && (
                <div className="absolute top-full left-0 w-80 bg-white rounded-lg shadow-lg border border-slate-200 z-50">
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-slate-500 mb-3 uppercase tracking-wide">Ressources</h3>
                    {ressourcesMenu.map((item, index) => (
                      <Link
                        key={index}
                        to={item.link}
                        className="block p-3 rounded-lg hover:bg-slate-50 transition-colors text-decoration-none text-black mb-2"
                      >
                        <div className="flex items-start">
                          <div className="text-2xl mr-3 border rounded-lg p-2">{item.icon}</div>
                          <div>
                            <h4 className="font-medium text-slate-900 mb-1 text-base">{item.title}</h4>
                            <p className="text-sm text-slate-600">{item.description}</p>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Menu utilisateur */}
            {effectiveUser ? (
              <div className='relative group'>
                <a href={`${NEW_APP_URL}/dashboard`} className='hover:bg-gray-100 px-4 py-2 text-decoration-none text-black rounded-2xl transition-colors flex items-center'>
                  {effectiveUser.name}
                </a>
                <div className='absolute hidden group-hover:block top-full right-0 z-10 text-black rounded'>
                  <ul className='list-none m-0 p-2 bg-white text-sm rounded-lg shadow-lg border border-slate-200 min-w-max'>
                    {!effectiveUser.isAccountVerified &&
                      <li onClick={sendVerificationOtp} className='py-2 px-3 hover:bg-gray-200 cursor-pointer rounded whitespace-nowrap'>
                        Verify Email
                      </li>
                    }
                    <li onClick={logout} className='py-2 px-3 hover:bg-gray-200 cursor-pointer rounded whitespace-nowrap'>
                      Déconnexion
                    </li>
                  </ul>
                </div>
              </div>
            ) : (
              <a href={`${NEW_APP_URL}/login`} className="hover:bg-gray-100 border px-4 py-2 text-decoration-none text-black rounded-full transition-colors">
                Connexion
              </a>
            )}

            {/* Demander une démo */}
            <Link to="/contact" className='bg-indigo-500 hover:bg-indigo-600 text-white px-4 py-2 text-decoration-none rounded-full transition-colors'>
              Demander une démo
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            >
              <span className="sr-only">Ouvrir le menu principal</span>
              {!isMobileMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-slate-200 shadow-lg">
            {/* Fonctionnalités Mobile */}
            <div>
              <button 
                onClick={() => setActiveDropdown(activeDropdown === 'fonctionnalites-mobile' ? null : 'fonctionnalites-mobile')}
                className="w-full flex justify-between items-center px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md"
              >
                Fonctionnalités
                <svg 
                  className={`w-5 h-5 transition-transform ${activeDropdown === 'fonctionnalites-mobile' ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {activeDropdown === 'fonctionnalites-mobile' && (
                <div className="pl-4 mt-2 space-y-1">
                  {fonctionnalitesMenu.map((item, index) => (
                    <Link
                      key={index}
                      to={item.link}
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-md text-decoration-none"
                    >
                      {item.title}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Ressources Mobile */}
            <div>
              <button 
                onClick={() => setActiveDropdown(activeDropdown === 'ressources-mobile' ? null : 'ressources-mobile')}
                className="w-full flex justify-between items-center px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md"
              >
                Ressources
                <svg 
                  className={`w-5 h-5 transition-transform ${activeDropdown === 'ressources-mobile' ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {activeDropdown === 'ressources-mobile' && (
                <div className="pl-4 mt-2 space-y-1">
                  {ressourcesMenu.map((item, index) => (
                    <Link
                      key={index}
                      to={item.link}
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-md text-decoration-none"
                    >
                      {item.title}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <hr className="my-3 border-gray-200" />

            {/* Actions Mobile */}
            {effectiveUser ? (
              <div>
                <a
                  href={`${NEW_APP_URL}/dashboard`}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md text-decoration-none"
                >
                  {effectiveUser.name}
                </a>
                {!effectiveUser.isAccountVerified &&
                  <button
                    onClick={() => { sendVerificationOtp(); setIsMobileMenuOpen(false); }}
                    className="block w-full text-left px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-md"
                  >
                    Verify Email
                  </button>
                }
                <button
                  onClick={() => { logout(); setIsMobileMenuOpen(false); }}
                  className="block w-full text-left px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-md"
                >
                  Déconnexion
                </button>
              </div>
            ) : (
              <a
                href={`${NEW_APP_URL}/login`}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md text-decoration-none"
              >
                Connexion
              </a>
            )}
            
            <Link 
              to="/contact" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="block mx-3 mt-4 px-4 py-2 bg-indigo-500 text-white text-center rounded-full hover:bg-indigo-600 transition-colors text-decoration-none"
            >
              Demander une démo
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default ClientNavbar;